@use '@/styles/tokens' as *;

/** Fieldset wrapper for the grouped range controls (No of Devices, Order Date Range).
 *  Mirrors FormField's vertical rhythm + label look so it lines up with the MultiSelectFields. */
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

.row {
  display: flex;
  gap: var(--space-3);
}

.error {
  margin: 0;
  padding-inline: var(--space-2);
  font-size: 11px;
  font-weight: 300;
  color: $color-error-900;
}
